export default "__VITE_ASSET__DrsLedGI__"